import handler from 'api/handler'

const prefix = '/public/activity'

const methods = {
  log: args => handler({ method: 'post', url: `${prefix}/log`, args })
}

export default methods

